export const UI_START_LOADING = 'UI_START_LOADING';
export const UI_STOP_LOADING = 'UI_STOP_LOADING';
export const UI_SHOW_LOGIN_MODAL = 'UI_SHOW_LOGIN_MODAL';
export const UI_HIDE_LOGIN_MODAL = 'UI_HIDE_LOGIN_MODAL';

export const AUTH_SET_USER_DETAILS = 'AUTH_SET_USER_DETAILS';
